/*
 * @Description: 运营人员管理
 * @Author: 杨志航
 * @Date: 2026-02-05 13:34:29
 */
import React, { useState, useEffect, useRef } from 'react'
import api from 'api'
import {
  Table,
  Form,
  Select,
  Input,
  Button,
  Alert,
  Popconfirm,
  message,
} from 'antd'
import { allTrim, filterParams } from '@/utils'
import Import from '@/components/Import'

const { Column } = Table
const FormItem = Form.Item
const Option = Select.Option
const isOnJobList = [{
  id: '1',
  name: '在职'
}, {
  id: '0',
  name: '离职'
}]

let pageSize = 10
let currentPage = 1
let searchParams = {
  limit: pageSize, 
  page: currentPage
}

const Operations = props => {
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue, getFieldsValue } = props.form
  const [count, setCount] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(true)
  const [importVisible, setImportVisible] = useState(false)
  const [departList, setDepartList] = useState([])
  const [companyList, setCompanyList] = useState([])
  const ImportRef = useRef()

  useEffect(() => {
    resetParams()
    getList()
    getSearchData()
  }, [])
  //获取检索所需数据
  const getSearchData =  () => {
    api.getAchOperationSearchList().then(res => {
      const { departments, companies } = res
      setDepartList(departments)
      setCompanyList(companies)
    })
  }

  const resetParams = () => {
    searchParams = {
      limit: pageSize, 
      page: currentPage
    }
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  //获取列表
  const getList = () => {
    api.getAchOperationList(searchParams).then(res => {
      const { list, count } = res
      setList(list)
      setCount(count)
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  //重置
  const onReset = () => {
    resetFields()
    currentPage = 1
    resetParams()
    getList()
  }
  //提交
  const formSubmit = evt => {
    evt.preventDefault()
    currentPage = 1
    resetParams()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        searchParams = {...searchParams, ...vals}
        getList()
      }
    })
  }
  //点击分页
  const onChangeTable = (pagination, filters, sorter) => {
    searchParams.page = currentPage = pagination.current
    searchParams.limit = pageSize = pagination.pageSize
    getList()
  }

  const onDelete = id => {
    api.delAchOperation({
      id: id
    }).then(() => {
      message.success('删除成功')
      getList()
    })
  }

  const onShowImportDialog = () => {
    ImportRef.current.onRemoved()
    setImportVisible(true)
  }

  const onConfirmImport = (fileList) => {
    if (fileList[0].status !== 'removed') {
      api.getAchImportOperation({
        file: fileList[0].url
      }).then(res => {
        message.success('导入成功')
        ImportRef.current.onLoading()
        setImportVisible(false)
        onReset()
      }).catch(res => {
        ImportRef.current.onLoading()
      })
    } else {
      message.error('请导入模板')
    }
  }

  return (
   <>
    <div className="search-doc-wrap">
        <Form onSubmit={formSubmit}  {...formItemLayout}>
          <div className="form-box">
            <FormItem label="公司用名">
              {getFieldDecorator('staffName')(<Input placeholder="请输入员工公司用名" />)}
            </FormItem>
            <FormItem label="所属部门">
              {getFieldDecorator('departmentId')(<Select 
                placeholder="请选择关所属部门"
                allowClear
                showSearch
                optionFilterProp="children"
              >
                {
                  departList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
                }
              </Select>)}
            </FormItem>
            <FormItem label="员工状态">
              {getFieldDecorator('isOnJob')(<Select 
                placeholder="请选择关员工状态"
                allowClear
              >
                {
                  isOnJobList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
                }
              </Select>)}
            </FormItem>
            <FormItem label="所属公司">
              {getFieldDecorator('companyId')(<Select 
                placeholder="请选择所属公司"
                allowClear
                showSearch
                optionFilterProp="children"
              >
                {
                  companyList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
                }
              </Select>)}
            </FormItem>
          </div>
          <FormItem className="btns" label=" " colon={false}>
            <Button type="primary" htmlType="submit">查询</Button>
            <Button onClick={onReset}>重置</Button>
          </FormItem>
        </Form>
      </div>
      <div className="line"></div>
      <div>
        <div className="add-wrap">
          <Button type="primary" icon="download" onClick={onShowImportDialog}>运营人员导入</Button>
        </div>
        <Alert className="corp-count" message={`总计：${count}条数据`} type="info" showIcon />
        <Table
          size="small"
          dataSource={list}
          rowKey="id"  
          loading={loading}
          pagination={{
            pageSize,
            total: count,
            current: currentPage,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
          }}
          onChange={onChangeTable}
        >
          <Column title="员工编号" dataIndex="staffNo" />
          <Column title="公司用名" dataIndex="staffName" />
          <Column title="直接主管" dataIndex="leaderName" />
          <Column title="所在部门" dataIndex="departmentName" />
          <Column title="所在事业群" dataIndex="groupName" />
          <Column title="职级" dataIndex="jobPositionCn" />     
          <Column title="员工状态" dataIndex="isOnJobCn" />
          <Column title="所属公司" dataIndex="companyName" />
          <Column title="操作"
            key="set" 
            fixed="right"
            align="center"
            width={80}
            render={(text, record) =>
              <Popconfirm title="请确认是否删除？" cancelText="取消" okText="确认" onConfirm={() => onDelete(record.id)}>
                <a>删除</a>
              </Popconfirm>
            }
          />
        </Table>
      </div>
      <Import
        onSearch={onConfirmImport}
        visibleFile={importVisible}
        onCloseImport={() => setImportVisible(false)}
        ImportTemplate="/templates/运营员工信息表.xlsx"
        ImportRef={ImportRef}
      />
   </> 
  )
}

export default Form.create()(Operations)